import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import { SuiteActions } from '../../store';
import * as util from '../../utils/urlParams';
import './SelectSuite.css';

export class SelectSuite extends Component {
  handleChange = (suite) => {
    const { setSelectedSuite, location, history } = this.props;
    const { search, pathname } = location;

    setSelectedSuite(suite);
    const filter = util.getFilterFromUrlParams(search);
    const selectedDataPoints = util.getDataPointsFromUrlParams(search);
    const newSearch = util.addThermostatSearchParams(filter, suite.value, selectedDataPoints);

    history.push(`${pathname}?${newSearch}`);
  };

  render() {
    const { suiteList, selectedSuite } = this.props;

    return (
      <div className="suite-select-wrapper">
        <span className="suite-select-title">Suite Details</span>
        <span className="suite-select-title__mobile">Change Suite</span>
        <Select
          name="suite-select"
          value={selectedSuite}
          options={suiteList}
          className="suite-select"
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

SelectSuite.propTypes = {
  suiteList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
  setSelectedSuite: PropTypes.func.isRequired,
  selectedSuite: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
};

SelectSuite.defaultProps = {
  suiteList: [],
  selectedSuite: {},
};

export function mapStateToProps(state) {
  return {
    suiteList: state.suiteReducer.formattedSuiteList,
    selectedSuite: state.suiteReducer.selectedSuite,
  };
}

const mapDispatchToProps = {
  setSelectedSuite: SuiteActions.setSelectedSuite,
};

const ConnectedSelectSuite = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectSuite);
export const ConnectedSelectSuiteWithRouter = withRouter(ConnectedSelectSuite);
